var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderMainImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1283,
    height: 479,
    viewBox: "0 0 1283 479",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2266_49",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1283,
    height: 479
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1283 0H0V479H1283V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2266_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.001 1321.06C995.186 1321.06 1282.31 1033.87 1282.31 679.6C1282.31 325.329 995.186 38.1357 641.001 38.1357C286.815 38.1357 -0.30957 325.329 -0.30957 679.6C-0.30957 1033.87 286.815 1321.06 641.001 1321.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.75 1321.06C964.146 1321.06 1225.5 1033.87 1225.5 679.6C1225.5 325.329 964.146 38.1357 641.75 38.1357C319.354 38.1357 58 325.329 58 679.6C58 1033.87 319.354 1321.06 641.75 1321.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.5 1321.06C914.053 1321.06 1135 1033.87 1135 679.6C1135 325.329 914.053 38.1357 641.5 38.1357C368.948 38.1357 148 325.329 148 679.6C148 1033.87 368.948 1321.06 641.5 1321.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.75 1321.06C863.735 1321.06 1044.5 1033.87 1044.5 679.6C1044.5 325.329 863.735 38.1357 640.75 38.1357C417.765 38.1357 237 325.329 237 679.6C237 1033.87 417.765 1321.06 640.75 1321.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.5 1321.06C813.194 1321.06 954 1033.87 954 679.6C954 325.329 813.194 38.1357 639.5 38.1357C465.806 38.1357 325 325.329 325 679.6C325 1033.87 465.806 1321.06 639.5 1321.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 1321.06C765.264 1321.06 866 1033.87 866 679.6C866 325.329 765.264 38.1357 641 38.1357C516.736 38.1357 416 325.329 416 679.6C416 1033.87 516.736 1321.06 641 1321.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.233 1321.06C713.92 1321.06 774.466 1033.87 774.466 679.6C774.466 325.329 713.92 38.1357 639.233 38.1357C564.546 38.1357 504 325.329 504 679.6C504 1033.87 564.546 1321.06 639.233 1321.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.188 1321.06C665.144 1321.06 685.375 1033.87 685.375 679.6C685.375 325.329 665.144 38.1357 640.188 38.1357C615.231 38.1357 595 325.329 595 679.6C595 1033.87 615.231 1321.06 640.188 1321.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.767 425.716C280.695 425.716 285.5 420.911 285.5 414.983C285.5 409.055 280.695 404.25 274.767 404.25C268.839 404.25 264.034 409.055 264.034 414.983C264.034 420.911 268.839 425.716 274.767 425.716Z",
    fill: "url(#paint0_linear_2266_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.267 187.175C246.195 187.175 251 182.369 251 176.442C251 170.514 246.195 165.709 240.267 165.709C234.339 165.709 229.534 170.514 229.534 176.442C229.534 182.369 234.339 187.175 240.267 187.175Z",
    fill: "url(#paint1_linear_2266_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.733 285.462C751.661 285.462 756.466 280.657 756.466 274.729C756.466 268.801 751.661 263.996 745.733 263.996C739.805 263.996 735 268.801 735 274.729C735 280.657 739.805 285.462 745.733 285.462Z",
    fill: "url(#paint2_linear_2266_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.139 394.513C925.067 394.513 929.872 389.707 929.872 383.78C929.872 377.852 925.067 373.047 919.139 373.047C913.211 373.047 908.406 377.852 908.406 383.78C908.406 389.707 913.211 394.513 919.139 394.513Z",
    fill: "url(#paint3_linear_2266_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.77 440.605C1183.7 440.605 1188.5 435.8 1188.5 429.872C1188.5 423.944 1183.7 419.139 1177.77 419.139C1171.84 419.139 1167.04 423.944 1167.04 429.872C1167.04 435.8 1171.84 440.605 1177.77 440.605Z",
    fill: "url(#paint4_linear_2266_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.733 66.458C767.661 66.458 772.466 61.6527 772.466 55.7251C772.466 49.7975 767.661 44.9922 761.733 44.9922C755.805 44.9922 751 49.7975 751 55.7251C751 61.6527 755.805 66.458 761.733 66.458Z",
    fill: "url(#paint5_linear_2266_49)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M898.817 137.148C898.817 157.453 882.377 173.924 862.077 173.924C841.777 173.924 825.353 157.468 825.353 137.148C825.353 116.828 841.808 100.387 862.077 100.387C882.346 100.387 898.817 116.843 898.817 137.148Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M862.492 100.802C882.177 100.802 898.186 116.828 898.186 136.532C898.186 156.236 882.177 172.262 862.492 172.262C842.808 172.262 826.799 156.236 826.799 136.532C826.799 116.828 842.808 100.802 862.492 100.802ZM862.492 97C840.67 97 823 114.703 823 136.532C823 158.361 840.685 176.064 862.492 176.064C884.299 176.064 902 158.361 902 136.532C902 114.703 884.315 97 862.492 97Z",
    fill: "url(#paint6_linear_2266_49)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M872.492 133.062H865.896V139.658H872.492V133.062Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M879.089 139.659H872.493V146.255H879.089V139.659Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M853.157 146.256V139.658V133.062V126.465H865.896H872.493V119.869H865.896H853.157H846.561V126.465V133.062V139.658V146.256V152.852H853.157H865.896H872.493V146.256H865.896H853.157Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M879.089 126.464H872.493V133.06H879.089V126.464Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.41 361.935C1099.41 391.235 1075.68 415.005 1046.39 415.005C1017.1 415.005 993.395 391.258 993.395 361.935C993.395 332.612 1017.14 308.887 1046.39 308.887C1075.64 308.887 1099.41 332.634 1099.41 361.935Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.99 309.487C1075.39 309.487 1098.5 332.612 1098.5 361.046C1098.5 389.48 1075.39 412.605 1046.99 412.605C1018.58 412.605 995.481 389.48 995.481 361.046C995.481 332.612 1018.58 309.487 1046.99 309.487ZM1046.99 304C1015.5 304 990 329.546 990 361.046C990 392.546 1015.52 418.092 1046.99 418.092C1078.46 418.092 1104 392.546 1104 361.046C1104 329.546 1078.48 304 1046.99 304Z",
    fill: "url(#paint7_linear_2266_49)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.42 356.039H1051.9V365.557H1061.42V356.039Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.94 365.557H1061.42V375.075H1070.94V365.557Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.52 375.077V365.557V356.039V346.518H1051.9H1061.42V337H1051.9H1033.52H1024V346.518V356.039V365.557V375.077V384.596H1033.52H1051.9H1061.42V375.077H1051.9H1033.52Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.94 346.518H1061.42V356.036H1070.94V346.518Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260.091 353.295C260.091 378.226 239.906 398.451 214.981 398.451C190.056 398.451 169.889 378.245 169.889 353.295C169.889 328.345 190.093 308.158 214.981 308.158C239.868 308.158 260.091 328.364 260.091 353.295Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M215.491 308.669C239.66 308.669 259.317 328.345 259.317 352.539C259.317 376.733 239.66 396.41 215.491 396.41C191.321 396.41 171.664 376.733 171.664 352.539C171.664 328.345 191.321 308.669 215.491 308.669ZM215.491 304C188.696 304 167 325.737 167 352.539C167 379.342 188.715 401.079 215.491 401.079C242.266 401.079 264 379.342 264 352.539C264 325.737 242.285 304 215.491 304Z",
    fill: "url(#paint8_linear_2266_49)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.768 348.279H219.669V356.378H227.768V348.279Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M235.869 356.377H227.77V364.476H235.869V356.377Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M204.029 364.478V356.378V348.279V340.178H219.67H227.77V332.079H219.67H204.029H195.93V340.178V348.279V356.378V364.478V372.577H204.029H219.67H227.77V364.478H219.67H204.029Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M235.869 340.178H227.77V348.277H235.869V340.178Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M637.817 383.148C637.817 403.453 621.377 419.924 601.077 419.924C580.777 419.924 564.353 403.468 564.353 383.148C564.353 362.828 580.808 346.387 601.077 346.387C621.346 346.387 637.817 362.843 637.817 383.148Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M601.492 346.802C621.177 346.802 637.186 362.828 637.186 382.532C637.186 402.236 621.177 418.262 601.492 418.262C581.808 418.262 565.799 402.236 565.799 382.532C565.799 362.828 581.808 346.802 601.492 346.802ZM601.492 343C579.67 343 562 360.703 562 382.532C562 404.361 579.685 422.064 601.492 422.064C623.299 422.064 641 404.361 641 382.532C641 360.703 623.315 343 601.492 343Z",
    fill: "url(#paint9_linear_2266_49)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M611.492 379.062H604.896V385.658H611.492V379.062Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M618.089 385.659H611.493V392.255H618.089V385.659Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M592.157 392.256V385.658V379.062V372.465H604.896H611.493V365.869H604.896H592.157H585.561V372.465V379.062V385.658V392.256V398.852H592.157H604.896H611.493V392.256H604.896H592.157Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M618.089 372.464H611.493V379.06H618.089V372.464Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M517.487 160.405C517.487 189.192 494.18 212.544 465.4 212.544C436.621 212.544 413.336 189.213 413.336 160.405C413.336 131.597 436.664 108.288 465.4 108.288C494.136 108.288 517.487 131.619 517.487 160.405Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M465.989 108.877C493.896 108.877 516.593 131.597 516.593 159.532C516.593 187.468 493.896 210.187 465.989 210.187C438.082 210.187 415.385 187.468 415.385 159.532C415.385 131.597 438.082 108.877 465.989 108.877ZM465.989 103.487C435.051 103.487 410 128.585 410 159.532C410 190.479 435.073 215.578 465.989 215.578C496.905 215.578 522 190.479 522 159.532C522 128.585 496.927 103.487 465.989 103.487Z",
    fill: "url(#paint10_linear_2266_49)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M480.166 154.613H470.814V163.965H480.166V154.613Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M489.519 163.965H480.167V173.316H489.519V163.965Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M452.755 173.318V163.964V154.613V145.259H470.814H480.168V135.908H470.814H452.755H443.404V145.259V154.613V163.964V173.318V182.669H452.755H470.814H480.168V173.318H470.814H452.755Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M489.519 145.259H480.167V154.61H489.519V145.259Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2266_49",
    x1: 274.767,
    y1: 404.25,
    x2: 274.767,
    y2: 425.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2266_49",
    x1: 240.267,
    y1: 165.709,
    x2: 240.267,
    y2: 187.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2266_49",
    x1: 745.733,
    y1: 263.996,
    x2: 745.733,
    y2: 285.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2266_49",
    x1: 919.139,
    y1: 373.047,
    x2: 919.139,
    y2: 394.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2266_49",
    x1: 1177.77,
    y1: 419.139,
    x2: 1177.77,
    y2: 440.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2266_49",
    x1: 761.733,
    y1: 44.9922,
    x2: 761.733,
    y2: 66.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2266_49",
    x1: 862.5,
    y1: 97,
    x2: 862.5,
    y2: 176.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2266_49",
    x1: 1047,
    y1: 304,
    x2: 1047,
    y2: 418.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2266_49",
    x1: 215.5,
    y1: 304,
    x2: 215.5,
    y2: 401.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2266_49",
    x1: 601.5,
    y1: 343,
    x2: 601.5,
    y2: 422.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2266_49",
    x1: 466,
    y1: 103.487,
    x2: 466,
    y2: 215.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMainImage);
export default __webpack_public_path__ + "static/media/Header-Main-Image.00bc991f5adc2f2d23f6e90801027d64.svg";
export { ForwardRef as ReactComponent };